module.exports = __webpack_public_path__ + "static/media/closeIcon.bf2ba4a1.svg";